/**
 * these imports are relative so that this will compile directly inline with base CASLink
 */

import MonitoringFanIcon from '!!raw-loader!../src/content/settings/svg/noun_Fan_100px.svg';

import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DomSanitizer } from '@angular/platform-browser';
import { DynamicStyleSheetService } from '@captiveaire/dynamicstylesheet';
import { ToastAbortService, ToastModule, ToastService } from '@captiveaire/toast';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import * as angular from 'angular';
import { MatTimepickerDirective, MatTimepickerModule } from 'mat-timepicker';
import { $httpProvider, $logProvider, $qProvider, $timeoutProvider, lodashProvider } from './ajs-upgraded-providers';
import { AlertBubbleModule } from './alert-bubble/alert-bubble.module';
import { AlertService } from './alerts/AlertService';
import { AnimatedEllipsisModule } from './animatedEllipsis/AnimatedEllipsisModule';
import { AppContextService } from './appContext/AppContextService';
import { AppSettingsService } from './appSettings/AppSettingsService';
import { AreaMenuModule } from './area-menu/area-menu.module';
import { AreaService } from './area/AreaService';
import { AreaSvgRegistrationService } from './area/AreaSvgRegistrationService';
import { AreaMenuIconModule } from './areaMenuIcon/AreaMenuIconModule';
import { AreaMenuItemModule } from './area-menu-item/area-menu-item.module';
import { AuthenticationService } from './authentication/AuthenticationService';
import { AutoShowOnChangeDirective } from './autoShowOnChange/AutoShowOnChangeDirective';
import { ClientVersionInfoService } from './clientVersionInfo/ClientVersionInfoService';
import { ClipboardService } from './clipboard/ClipboardService';
import { CommonBroadcastService } from './common-broadcast/common-broadcast.service';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { PageSelectDialogComponent } from './analytics/PageSelectDialog/PageSelectDialogComponent';
import { CustomerService } from './customer/CustomerService';
import { DialogService } from './dialog-service/dialog.service';
import { AnalyticsDlgService } from './analytics/DialogService/AnalyticsDlgService';
import { DisableControlDirective } from './disableControl/DisableControlDirective';
import { EndpointService } from './endpoint/EndpointService';
import { ExportSensorDataService } from './exportSensorData/ExportSensorDataService';
import { BooleanValuePipe } from './formatBooleanValue/FormatBooleanValuePipe';
import { FormatDeviceConfigurationPipe } from './formatDeviceConfiguration/FormatDeviceConfigurationPipe';
import { FormatTimespanValuePipe } from './formatTimespanValue/FormatTimespanValuePipe';
import { FormsModule as CommonFormsModule } from './forms/FormsModule';
import { GravatarComponent } from './gravatar/GravatarComponent';
import { AngularUpgradeHelper } from './helpers/AngularUpgradeHelper';
import { HoverInfoComponent } from './hoverInfo/HoverInfoComponent';
import { IdentifiableService } from './identifiable/IdentifiableService';
import { JobNumberPopupService } from './jobNumberPopup/JobNumberPopupService';
import { LastLoadedLocationService } from './lastLoadedLocation/LastLoadedLocationService';
import { LoadingAnimationModule } from './loadingAnimation/LoadingAnimationModule';
import { CommonLocationService } from './location/CommonLocationService';
import { LocationLoadedEventService } from './locationLoaded/LocationLoadedEventService';
import { LocationSummaryService } from './locationSummary/LocationSummaryService';
import { LodashFactory } from './lodash/LodashFactory';
import { LoggingService } from './logging/LoggingService';
import { MaxIntValueService } from './maxIntValue/MaxIntValueService';
import { ModbusService } from './modbus/ModbusService';
import { ModuleSummaryService } from './moduleSummary/ModuleSummaryService';
import { DeviceHardwareItemQueryService } from './deviceHardwareItemQuery/DeviceHardwareItemQueryService';
import { ModuleViewNavigationService } from './moduleViewNavigationService/ModuleViewNavigationService';
import { ToolbarInfoService } from './nav-toolbar/toolbar-info.service';
import { NextInputService } from './nextInput/NextInputService';
import { NotificationService } from './notification/NotificationService';
import { PopupButtonContainerComponent } from './popupButtonContainer/PopupButtonContainerComponent';
import { PopupHeaderComponent } from './popupHeader/PopupHeaderComponent';
import { ProxyService } from './proxy/ProxyService';
import { RequestContextService } from './requestContext/RequestContextService';
import { ScrollbarService } from './scrollbar/ScrollbarService';
import { SearchHistoryService } from './searchHistory/SearchHistoryService';
import { SelectableService } from './selectable/SelectableService';
import { SelectTimePickerComponent } from './selectTimePicker/SelectTimePickerComponent';
import { SplitTimeInputComponent } from './split-time-input/split-time-input.component';
import { StateStorageService } from './stateStorage/StateStorageService';
import { StepCounterComponent } from './stepCounter/StepCounterComponent';
import { StrippedMacPipe } from './strippedMac/StrippedMacPipe';
import { TableUpdateSubscriptionService } from './table/TableUpdateSubscriptionService';
import { TabService } from './tabs/TabService';
import { ThemeService } from './theme/ThemeService';
import { ThemePreferenceService } from './themePreference/ThemePreferenceService';
import { TimeRangeComponent } from './timeRange/TimeRangeComponent';
import { UndoService } from './undo/UndoService';
import { UserInfoModule } from './userInfo/user-info.module';
import { UserInformationService } from './userInformation/UserInformationService';
import { StringUtilsService } from './utilities/StringUtils';
import { Utilities } from './utilities/Utilities';
import { VirtualRepeaterSearchService } from './virtualRepeater/VirtualRepeaterSearchService';
import { WINDOW_PROVIDERS } from './window/WindowService';
import { ZeroPaddingDirective } from './zeroPadding/ZeroPaddingDirective';
import { ZipValidationService } from './zipValidator/ZipValidatorService';
import { UserPermissionService } from './userPermission/UserPermissionService';
import { SubToolbarModule } from '@caslink/common-client/ng-app/sub-toolbar/sub-toolbar.module';
import { NavToolbarModule } from '@caslink/common-client/ng-app/nav-toolbar/nav-toolbar.module';
import { SideFiltersModule } from '@caslink/common-client/ng-app/side-filters/side-filters.module';
import { CenterContentModule } from '@caslink/common-client/ng-app/center-content/center-content.module';
import { ConnectionStatusModule } from '@caslink/common-client/ng-app/connection-status/connection-status.module';
import { ClDragDirective } from './drag-drop/drag.directive';
import { CellularDeviceStatusFormatPipe } from './cellular-device-status-format/cellular-device-status-format.pipe';
import { ErrorModule } from '@caslink/common-client/ng-app/error/error.module';
import {
    CellularDeviceStatusModule,
} from '@caslink/common-client/ng-app/celluar-device-status/cellular-device-status.module';
import {
    StatusIndicatorListModule,
} from '@caslink/common-client/ng-app/status-indicator-list/status-indicator-list.module';
import { MenuModule } from '@caslink/common-client/ng-app/menu/menu.module';
import { ClDropDirective } from './drag-drop/drop.direcive';
import { BulkActionModule } from '@caslink/common-client/ng-app/bulk-action/bulk-action.module';
import { JobNumberModule } from '@caslink/common-client/ng-app/job-number/job-number.module';
import { BulkActionService } from './bulk-action/bulk-action.service';
import { EditableContentModule } from '@caslink/common-client/ng-app/editable-content/editable-content.module';
import { CellularDeviceActivationService } from './cellular-device-activation/cellular-device-activation.service';
import { CellularDeviceActivationComponent } from './cellular-device-activation/cellular-device-activation.component';
import { LocationAreaMenuService } from './location-area-menu/location-area-menu.service';
import { CellularDeviceDeactivationService } from './cellular-device-deactivation/cellular-device-deactivation.service';
import {
    CellularDeviceDeactivationComponent,
} from './cellular-device-deactivation/cellular-device-deactivation.component';
import { CellularCarrierService } from './cellular-device/cellular-carrier.service';
import { CellularDeviceAssignmentService } from './cellular-device/cellular-device-assignment.service';
import {
    CellularDeviceCommunicationHardwareService,
} from './cellular-device/cellular-device-communication-hardware.service';
import {
    CellularDeviceInfoIdentifierMappingService,
} from './cellular-device/cellular-device-info-identifier-mapping.service';
import { CellularDeviceService } from './cellular-device/cellular-device.service';
import { CellularDeviceSelectorComponent } from './cellular-device-selector/cellular-device-selector.component';
import { AutoFocusModule } from './auto-focus/auto-focus.module';
import { GoogleAnalyticsModule } from '@caslink/common-client/ng-app/google-analytics/google-analytics.module';
import { GoogleAnalyticsComponent } from '@caslink/common-client/ng-app/google-analytics/google-analytics.component';
import { DateRangeComponent } from './date-range/date-range.component';
import {
    ExportSensorDialogComponent,
} from '@caslink/common-client/ng-app/export-sensor-data-dialog/export-sensor-dialog.component';
import {
    ExportSensorDialogService,
} from '@caslink/common-client/ng-app/export-sensor-data-dialog/export-sensor-dialog.service';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DynamicMatDialog } from './dynamic-dialog/dynamic-dialog';
import { HighchartsService } from './highcharts/highcharts.service';
import { TogglerModule } from './toggler/toggler.module';
import { HighchartsModule } from './highcharts/highcharts.module';
import { LazyLoaderService } from './lazy-loader/lazy-loader.service';
import { BasicTreeModule } from './basic-tree/basic-tree.module';
import { BingMapService } from './bing-map/bing-map.service';
import { BingMapModule } from './bing-map/bing-map.module';
import { CancelablePromiseService } from './cancelable-promise/cancelable-promise.service';
import { CommonDeviceDetectorService } from './device-detector/device-detector.service';
import { TreeViewCellService } from '@caslink/device-client/ng-app/tree-view-cell/tree-view-cell.service';
import { ResizableModule } from 'angular-resizable-element';
import { ResizableMapModule } from './resizableMap/resizable-map.module';
import { LocationScopedCacheService } from './location-scoped-cache/location-scoped-cache.service';
import { ColorService } from '@caslink/common-client/ng-app/color-service/color.service';
import { DigitOnlyDirective } from './selectTimePicker/digits-only.directive';

@NgModule({
    imports: [
        AlertBubbleModule,
        AnimatedEllipsisModule,
        AreaMenuIconModule,
        AreaMenuItemModule,
        CommonModule,
        FormsModule,
        FlexLayoutModule,
        HttpClientModule,
        LoadingAnimationModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        MatListModule,
        MatToolbarModule,
        ReactiveFormsModule,
        ToastModule,
        UIRouterUpgradeModule.forRoot(),
        MatTimepickerModule,
        UserInfoModule,
        AreaMenuModule,
        SubToolbarModule,
        NavToolbarModule,
        SideFiltersModule,
        CenterContentModule,
        ErrorModule,
        ConnectionStatusModule,
        CellularDeviceStatusModule,
        StatusIndicatorListModule,
        MenuModule,
        BulkActionModule,
        JobNumberModule,
        EditableContentModule,
        AutoFocusModule,
        GoogleAnalyticsModule,
        MatRadioModule,
        CommonFormsModule,
        MatDatepickerModule,
        TogglerModule,
        HighchartsModule,
        BasicTreeModule,
        BingMapModule,
        ResizableModule,
        ResizableMapModule,
    ],
    // tslint:disable-next-line: object-literal-sort-keys
    declarations: [
        AutoShowOnChangeDirective,
        DisableControlDirective,
        GravatarComponent,
        StepCounterComponent,

        HoverInfoComponent,

        PopupButtonContainerComponent,
        PopupHeaderComponent,
        SelectTimePickerComponent,
        TimeRangeComponent,

        ConfirmDialogComponent,
        PageSelectDialogComponent,

        SplitTimeInputComponent,
        ZeroPaddingDirective,

        BooleanValuePipe,
        FormatDeviceConfigurationPipe,
        FormatTimespanValuePipe,
        StrippedMacPipe,
        ClDragDirective,
        CellularDeviceStatusFormatPipe,
        ClDropDirective,
        CellularDeviceActivationComponent,
        CellularDeviceDeactivationComponent,
        CellularDeviceSelectorComponent,
        DateRangeComponent,
        ExportSensorDialogComponent,
        DigitOnlyDirective,
    ],
    entryComponents: [
        GravatarComponent,
        StepCounterComponent,

        HoverInfoComponent,

        PopupButtonContainerComponent,
        PopupHeaderComponent,
        SelectTimePickerComponent,
        TimeRangeComponent,

        ConfirmDialogComponent,
        PageSelectDialogComponent,

        SplitTimeInputComponent,
        CellularDeviceActivationComponent,
        CellularDeviceDeactivationComponent,
        CellularDeviceSelectorComponent,
        DateRangeComponent,
        ExportSensorDialogComponent,
    ],
    exports: [
        AutoShowOnChangeDirective,
        DisableControlDirective,
        GravatarComponent,
        StepCounterComponent,

        HoverInfoComponent,

        PopupButtonContainerComponent,
        PopupHeaderComponent,
        SelectTimePickerComponent,
        TimeRangeComponent,

        ConfirmDialogComponent,
        PageSelectDialogComponent,
        SplitTimeInputComponent,

        BooleanValuePipe,
        FormatDeviceConfigurationPipe,
        FormatTimespanValuePipe,
        StrippedMacPipe,
        ClDragDirective,
        CellularDeviceStatusFormatPipe,
        ClDropDirective,
        CellularDeviceActivationComponent,
        CellularDeviceSelectorComponent,
        GoogleAnalyticsComponent,
        DateRangeComponent,
        ExportSensorDialogComponent,
        DigitOnlyDirective,
    ],
    providers: [
        $httpProvider,
        $logProvider,
        $qProvider,
        $timeoutProvider,
        lodashProvider,
        WINDOW_PROVIDERS,

        BooleanValuePipe,
        FormatDeviceConfigurationPipe,
        FormatTimespanValuePipe,
        StrippedMacPipe,

        NextInputService,
        NotificationService,
        ToolbarInfoService,
        ThemeService,

        JobNumberPopupService,
        ModuleViewNavigationService,
        MatTimepickerDirective
    ]
})
export class AppModule {
    private commonModuleName = 'app.areas.common';

    constructor(
        private iconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer
    ) {
        this.registerComponents();
        this.registerFactories();
        this.registerServices();
        this.run();
        this.registerIcons();
    }

    private registerComponents() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            GravatarComponent,
            StepCounterComponent,

            SelectTimePickerComponent,
            TimeRangeComponent,
            SplitTimeInputComponent,
            CellularDeviceActivationComponent,
            CellularDeviceDeactivationComponent,
            CellularDeviceSelectorComponent,
            DateRangeComponent,
        ]);
    }

    private registerFactories() {
        AngularUpgradeHelper.downgradeFactories(this.commonModuleName, [
            LodashFactory
        ]);
    }

    private registerServices() {
        AngularUpgradeHelper.downgradeServices(this.commonModuleName, [
            AlertService,
            AppContextService,
            AppSettingsService,
            AreaService,
            AreaSvgRegistrationService,
            AuthenticationService,
            ClientVersionInfoService,
            ClipboardService,
            CommonBroadcastService,
            CommonLocationService,
            CustomerService,
            DynamicStyleSheetService,
            EndpointService,
            ExportSensorDataService,
            IdentifiableService,
            JobNumberPopupService,
            LastLoadedLocationService,
            LocationLoadedEventService,
            LocationSummaryService,
            LoggingService,
            MaxIntValueService,
            ModbusService,
            ModuleSummaryService,
            DeviceHardwareItemQueryService,
            NotificationService,
            ProxyService,
            RequestContextService,
            SearchHistoryService,
            ScrollbarService,
            SelectableService,
            StateStorageService,
            StringUtilsService,
            TabService,
            ToastAbortService,
            ToastService,
            TableUpdateSubscriptionService,
            ThemePreferenceService,
            ToolbarInfoService,
            UndoService,
            UserInformationService,
            Utilities,
            VirtualRepeaterSearchService,
            ZipValidationService,
            UserPermissionService,
            DialogService,
            AnalyticsDlgService,
            BulkActionService,
            CellularDeviceActivationService,
            LocationAreaMenuService,
            CellularDeviceDeactivationService,
            CellularCarrierService,
            CellularDeviceAssignmentService,
            CellularDeviceCommunicationHardwareService,
            CellularDeviceInfoIdentifierMappingService,
            CellularDeviceService,
            ExportSensorDialogService,
            DynamicMatDialog,
            HighchartsService,
            LazyLoaderService,
            BingMapService,
            CancelablePromiseService,
            CommonDeviceDetectorService,
            TreeViewCellService,
            LocationScopedCacheService,
            ColorService,
        ]);
    }

    private run() {
        angular.module(this.commonModuleName)
            .run([
                ClientVersionInfoService.$name,
                LodashFactory.$name,
                AreaSvgRegistrationService.$name,
                (
                    clientVersionInfoService: ClientVersionInfoService,
                    // Must run to enforce no use of global _ variable
                    lodash: _.LoDashStatic,
                    areaSvgRegistrationService: AreaSvgRegistrationService,
                ) => {
                    clientVersionInfoService.log();
                    // Only load area icons from the API and register them if logged in.  Otherwise, endpoints won't exist for the API call.
                    if (window['App']) {
                        const areaSvgApiUrl = window['App'].metadata.endpoints.icon.routes.getAreaIcons.routeTemplate;
                        areaSvgRegistrationService.registerMatIcons(areaSvgApiUrl);
                    }
                }]);
    }

    private registerIcons() {
        const icons = [
            {
                name: 'monitoringFan',
                svg: MonitoringFanIcon
            },
        ];

        icons.forEach(icon => {
            this.iconRegistry.addSvgIconLiteral(icon.name, this.sanitizer.bypassSecurityTrustHtml(icon.svg));
        });
    }
}
